"use client";
import { useEffect, useRef, useState } from "react";
import { getFileBaseUrl, uploadFileWithSignedUrl } from "../../services/FilesService";
import { makeCall } from "../../state/actions/phone";
import { useDispatch, useSelector } from "react-redux";
import { ImagePath } from "../../assets/ImagePath";
import { getAuthData, getSessinIdFromLS } from "../../services/storage/LocalStorage";
import { appType } from "../../utils/config/configHelpers";
import config from "../../utils/config/config";
import { getGroupProfileImageUrl, getUserInitials, getUserProfileImageUrlThumbnail, isValidImageUrl } from "../../utils/general";
import { getTimeLine, setActiveMessageChatAreaDetail, toggleConversationFavouriteStatus, updateTimeLine } from "../../state/actions/chats";
import { FAVORITE_STAR_DISABLED, FAVORITE_STAR_SELECTED, FAVORITE_STAR_UNSELECTED } from "../../utils/constants";
import Groupinfo from "./Groupinfo";
import Searchbar from "./Searchbar";
import Memberlist from "./Memberlist";
import EditGroupModal from "../../components/ui/Modals/EditGroupModal";
import ModalNewUI from "../../components/ui/Modals/ModalMessages/ModalNewUI";
import ModalComfirm from "../../components/ui/Modals/ModalMessages/ModalConfirm";
import { updateParticipants, uploadImageFile, UserServiceClientApi } from "../../services/api/UserApiServices";
import { showToast } from "../../components/ui/toaster";
import { fetchAllChannels, fetchSubscribedChannels } from "../../state/actions/channels";
import DeleteGroupModal from "../../components/ui/Modals/ModalMessages/DeleteGroupModal";
import FrontmGifLogoLoader from "../../components/ui/Loader/frontmGifLogoLoader";
import { removeBotStyles, scriptSrc } from "../../utils/ChatbotScriptHelpers";
import { updateProfileImage } from "../../state/actions/updateProfileImage";
import webSocketApiService from "../../services/socket/wsApiServices";
import { responsiveFontSizes } from "@mui/material";
import { SOCKET } from "../../services/socket/initWebSocket";


const ChatScreen = ({
    selectedContactDetails,
    filteredConversations,
    activeFilter,
    searchInput,
    loader,
    setLoader,
    userID,
    handleLeaveGroup,
    openLeaveModal,
    setOpenLeaveModal,
    setOpenDeleteModal,
    openDeleteModal,
    handleDeleteGroup,
    setOpenGroupInfo,
    openGroupInfo,
    timeLine,
    setSelectedContact,
    setAvatarUrl,
    avatarUrl,
    selectedContactDomain,
    setReloadChat,
    reloadChat,
    getUpdatedImg
}) => {
    const [profileUtils, setProfileUtils] = useState(null);
    const [showGroupSetting, setShowGroupSetting] = useState(false)

    const favourites = useSelector((state) => state?.chats?.favourites);
    const channels = useSelector((state) => state?.channels?.channels);
    const contentList = useSelector((state) => state.contacts.contentList);
    const channelAdmins = useSelector((state) => state.channels.channelAdmins);
    const activeMessageChatArea = useSelector((state) => state.chats.activeMessageChatArea);

    const dispatch = useDispatch();
    const isChannelAdmin = channelAdmins.some((user) => user.userId === userID)
    const isGroupOwner = selectedContactDetails?.channelOwner?.userId === userID

    const checkIsContactFavourite = () =>
        favourites?.some(
            fav =>
                fav?.contact?.userId !== undefined && fav?.contact?.userId === (selectedContactDetails?.contact?.userId || selectedContactDetails?.userId)
                ||
                fav?.conversationId !== undefined && fav?.conversationId === selectedContactDetails?.channelId
        ) ?? false; // make sure its always bool


    const getFavouriteIconImage = (contact) => {
        // if (contact?.favActionInProgress) return FAVORITE_STAR_DISABLED;
        if (checkIsContactFavourite()) {
            return FAVORITE_STAR_SELECTED
        } else {
            return FAVORITE_STAR_UNSELECTED;
        }
    };


    useEffect(() => {
        const loadAvatar = async () => {
            if (selectedContactDetails && (selectedContactDetails?.contact?.userId || selectedContactDetails?.userId)) {
                const { userId, userName } = (selectedContactDetails?.contact || selectedContactDetails)
                try {
                    const url = getUserProfileImageUrlThumbnail(userId);
                    let isValid = await isValidImageUrl(url);
                    if (isValid) {
                        setAvatarUrl(url);
                    }
                    else {
                        const profileUtils = getUserInitials(userName);
                        setProfileUtils(profileUtils);
                        setAvatarUrl(null);
                    }
                } catch (error) {
                    console.log("Error fetching image", error);

                }
            }

            else if (selectedContactDetails && selectedContactDetails?.channelId) {
                const url = getGroupProfileImageUrl(selectedContactDetails?.channelId);
                let isValid = await isValidImageUrl(url);
                if (isValid) {
                    setAvatarUrl(url);
                } else {
                    const profileUtils = getUserInitials(selectedContactDetails?.channelName);
                    setProfileUtils(profileUtils);
                    setAvatarUrl(null);
                }

            } else {
                const profileUtils = getUserInitials(selectedContactDetails?.channelName);
                setProfileUtils(profileUtils);
            }

        };

        loadAvatar();
        getFavouriteIconImage()
    }, [selectedContactDetails]);


    const toggleContactTofavourites = (contact) => {
        // if (contact?.favActionInProgress) return;

        setSelectedContact((pre) => ({
            ...pre,
            favourite: !pre.favourite,
        }));
        const channelId = contact.channelId || channels.find((x) => x?.channelOwner?.userId === contact?.contact?.userId)?.channelId || contact?.conversationId;

        if (contact.contact) {
            // Find conversationId from timeline if not directly available
            const conversationId = contact.conversationId || timeLine.find(
                (conv) =>
                    (conv?.contact?.userId === (contact?.contact?.userId || contact?.userId)) &&
                    conv.conversationId
            )?.conversationId;

            dispatch(toggleConversationFavouriteStatus({
                userId: contact?.contact?.userId || contact?.userId,
                conversationId: conversationId,
                action: checkIsContactFavourite() ? "remove" : "add",
            }));
        } else if (contact.channelId) {
            dispatch(toggleConversationFavouriteStatus({
                conversationId: channelId,
                action: checkIsContactFavourite() ? "remove" : "add",
            }));
        }
    };

    const handleAudioCall = (data) => {
        if (!data) return;

        const { emailAddress, userId, userName, conversation } = data;
        if (userId) {
            dispatch(makeCall('voip', emailAddress, userId, userName, userId, null, 'on-call'))
        } else if ((!userId && conversation)) {
            dispatch(makeCall('voip', 'channel', conversation?.channelId, conversation?.channelName, conversation?.channelId, null, 'on-call'))
        }
    };

    const handleVideoCall = (data) => {
        if (!data) return;
        const { emailAddress, userId, userName, conversation } = data;
        if (userId) {
            dispatch(makeCall('voip', emailAddress, userId, userName, userId, null, 'on-call', true))
        } else if ((!userId && conversation)) {
            dispatch(makeCall('voip', 'channel', conversation?.channelId, conversation?.channelName, conversation?.channelId, null, 'on-call', true))
        }
    };


    const getFallback = () => {
        if (searchInput?.trim() && filteredConversations.length === 0) {
            return {
                image: ImagePath.searchResult,
                heading: "Oops! No Result Found",
                text: "No results found try adjusting your search or using different keywords",
            };
        }

        if (!activeMessageChatArea) {
            return {
                image: ImagePath.messageScreenEmpty,
                heading: "Nothing’s Happening Here Yet",
                text: "Select a chat or group to get the conversation started",
            };
        }

        if (filteredConversations.length > 0) return null;
        if (activeFilter === "unread") {
            return {
                image: ImagePath.unreadMessage,
                heading: "No Unread Messages",
                text: "You're all caught up, no unread messages",
            };
        }
        if (activeFilter === "favorites") {
            return {
                image: ImagePath.noFavourites,
                heading: "No Favorites Added",
                text: "You haven’t added any favorites yet mark items to find them here easily",
            };
        }
        return null;
    };

    const fallback = getFallback();

    const selectedConversation = useSelector((state) => state?.chats.selectedConversation || null);
    const selectedDomain = useSelector((state) => state.domain.selectedDomain);
    const isOneToOneChat = useSelector((state) => state.chats.oneToOneChat);
    const selectedGroupChatParticipants = useSelector((state) => state.chats.selectedGroupChatParticipants);

    const [editGroupModal, setEditGroupModal] = useState(false)
    const [searchMembers, setSearchMembers] = useState('');
    const [restartKey, setRestartKey] = useState(0);

    const sessionId = getSessinIdFromLS();
    const userDetail = getAuthData();
    const userData = userDetail?.user || {};

    useEffect(() => {
        if (loader) {
            // only update key when loader turns true
            setRestartKey(Date.now());
        }
    }, [loader]);

    useEffect(() => {
        setOpenGroupInfo(false);
        dispatch(fetchAllChannels(selectedDomain))
    }, []);


    window.tapCallFromChatbotScript = function (callData) {

        if (!callData) return;

        const data = {
            emailAddress: userDetail?.user?.emailAddress,
            userId: (selectedContactDetails?.contact?.userId || selectedContactDetails?.userId),
            userName: userDetail?.user?.userName,
            conversation: selectedContactDetails
        }
        if (callData.info?.callType === "voice") {
            handleAudioCall(data);
        }
        else {
            handleVideoCall(data);
        }
    };

    useEffect(() => {
        window.CurrentEnvironement = process.env.REACT_APP_ENV || 'development';
        const botId = selectedConversation?.bot?.botId;
        const convId = selectedConversation?.conversationId;
        const isIMBotChat = selectedConversation?.contact || selectedConversation?.channel || false

        const isValid = botId && convId;

        if (isValid && isIMBotChat && activeMessageChatArea && selectedConversation, selectedContactDetails) {
            performCleanupAndLoad();
        }
    }, [selectedConversation, activeMessageChatArea, reloadChat, selectedContactDetails]);


    const performCleanupAndLoad = async () => {
        const response = await fullBotReset();
        if (response === true) {
            setTimeout(() => {
                loadBotScriptStyles();
                loadBotScript();
            }, 300);

            setTimeout(() => {
                loadBotScriptStyles();
                loadBotScript();
            }, 1000); // Delay a bit more to avoid script clash
        }
    };

    const fullBotReset = async () => {
        try {
            if (typeof window.destroyChatWidget === "function") {
                window.destroyChatWidget();
            }
        } catch (err) {
            console.warn("Error while calling destroyChatBot script:", err);
        }
        removeBotScript();
        removeBotStyles();
        window.getParamsFromFrontmNewWebApp = null;
        const root = document.getElementById("chat-bot-project-root");
        if (root) root.innerHTML = "";
        return true;
    };

    const loadBotScriptStyles = () => {
        if (!document.getElementById('chatbot-project-styles-assistantBot')) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = '/scripts/chatwidget/messagePageChatCss/main.7d6c5bdb.css';
            link.id = 'chatbot-project-styles-assistantBot';
            document.head.appendChild(link);
        }
    };

    const loadBotScript = () => {
        const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
        if (existingScript) {
            removeBotScript();
        }

        setTimeout(() => {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = true;
            script.onload = () => {
                setTimeout(() => waitForWidgetInit(), 1000);
            };
            script.onerror = (e) => {
                console.error("Error loading the script: ", e);
                setLoader(false)
            };
            document.body.appendChild(script);
        }, 400);
    };

    const waitForWidgetInit = () => {
        const botRoot = document.getElementById("chat-bot-project-root");
        if (!botRoot) {
            console.error("chat-bot-project-root not found.");
            return;
        }

        const isReady = () => (
            typeof window.getParamsFromFrontmNewWebApp === "function" &&
            botRoot?.querySelector("*")
        );

        const attemptToSendParams = () => {
            if (isReady()) {
                sendParamsToEmbeddedChatbot();
                return true;
            }
            return false;
        };

        if (attemptToSendParams()) return;
        const observer = new MutationObserver(() => {
            if (attemptToSendParams()) {
                observer.disconnect();
            }
        });

        observer.observe(botRoot, { childList: true, subtree: true });

        setTimeout(() => {
            observer.disconnect();
            if (!attemptToSendParams()) {
            }
        }, 5000);
    };

    const sendParamsToEmbeddedChatbot = async (retryCount = 0) => {
        if (!isOneToOneChat && !selectedContactDetails?.channelName) return;
        if (!selectedConversation?.conversationId) return;

        const maxRetries = 5;
        // let connectionId = localStorage.getItem("connectionId");
        // const refreshToken = localStorage.getItem("refreshToken");
        // Generate/fetch new connectionId before sending params
        // try {
        //     const res = await webSocketApiService.GetWSConnectionId();
        //     if (res?.success && res?.connectionId) {
        //         localStorage.setItem("connectionId", res.connectionId);
        //         console.log("Generated new connectionId:", res.connectionId);
        //         connectionId = res.connectionId;
        //     }
        // } catch (error) {
        //     console.error("Error generating connectionId:", error);
        // }

        let params = null
        if (isOneToOneChat) {
            params = {
                oneToOneChat: true,
                userEmail: userData?.emailAddress || "",
                userId: userDetail?.user?.userId || "",
                sessionId: sessionId || userDetail?.auth?.sessionId,
                appType: appType,
                platform: "web",
                isDisableChat: selectedContactDetails?.isRequestPendingForAccept ?? false,
                domain: selectedContactDomain || selectedDomain || selectedConversation?.userDomain,
                conversationId: selectedConversation?.conversationId || "",
                participantName: selectedConversation?.contact?.userName || "",
                participantImage: selectedConversation?.contact?.userId ? getUserProfileImageUrlThumbnail(selectedConversation?.contact?.userId) : "",
                participantId: selectedConversation?.contact?.userId || "",
                // connectionId: connectionId || "",
                // refreshToken: refreshToken || "",
                ws: SOCKET.ws
            };
        }
        else {
            params = {
                groupChat: true,
                userEmail: userData?.emailAddress || "",
                userId: userDetail?.user?.userId || "",
                sessionId: sessionId || userDetail?.auth?.sessionId,
                appType: appType,
                platform: "web",
                domain: selectedContactDomain || selectedDomain || selectedConversation?.userDomain,
                conversationId: selectedConversation?.conversationId || "",
                //Group chat specific
                channelName: selectedContactDetails?.channelName || "",
                chatParticipants: selectedGroupChatParticipants || [],
                // connectionId: connectionId || "",
                // refreshToken: refreshToken || "",
                chatOff: selectedContactDetails?.chatOff,
                ws: SOCKET.ws
            };
        }

        if (typeof window.getParamsFromFrontmNewWebApp === "function") {
            window.getParamsFromFrontmNewWebApp(params);
            setLoader(false);
        } else if (retryCount < maxRetries) {
            setTimeout(() => sendParamsToEmbeddedChatbot(retryCount + 1), 500);
        } else {
            // console.error("Bot script did not initialize in time for chatwidget.");
        }
    };

    const removeBotScript = () => {
        const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
        if (existingScript && existingScript.parentNode) {
            existingScript.parentNode.removeChild(existingScript);
        }
    };


    const closeLeaveModal = () => {
        setOpenLeaveModal(false)
    };

    const closeDeleteModal = () => {
        setOpenDeleteModal(false)
    };

    const openGroupModal = () => {
        console.log('Opening Edit Group Modal');
        if (showGroupSetting) {
            setShowGroupSetting(false);
        }
        setEditGroupModal(true);
    };


    const fetchAllChannelsNSubChannels = () => {
        console.log("fetching everything");
        let selectedDomainObj = {
            selectedDomain: selectedDomain,
        };
        dispatch(fetchAllChannels(selectedDomain))
        dispatch(fetchSubscribedChannels(selectedDomainObj))
    };

    const giveUnique = (arr1, arr2) => {
        if (arr1.length > arr2.length) {
            return arr1.filter((e) => !arr2.includes(e));
        } else {
            return arr2.filter((e) => !arr1.includes(e));
        }
    };

    const uploadChannelImg = (channelId, fileName, file) => {
        let payload = {
            "fileScope": "channelLogo",
            "fileName": fileName,
            "channelId": channelId
        }
        webSocketApiService.GetSignedUrlsForUpload(payload)
            .then((res) => {
                if (res?.signedThumbnailUrl) {
                    uploadFileWithSignedUrl(res.signedThumbnailUrl, file);
                }
                fetchAllChannelsNSubChannels();
            })
            .catch((error) => {
                console.error("Error in uploading group image", error);
            });
    };

    const getSubscibedChannels = async () => {
        try {
            const response = await webSocketApiService.GetSubscribed();
            if (response) {
                const list = response.content ?? [];
                const getUpdatedChannelData = list.find((item) => item?.channelId === selectedContactDetails?.channelId);
                setSelectedContact(getUpdatedChannelData)
                dispatch(setActiveMessageChatAreaDetail(getUpdatedChannelData))
            }
        } catch (err) {
            console.error("Error fetching subscribed channels:", err);
        }
    };
    const editChannel = (data) => {
        let { description, participants, channelId, channelName, chatOff } = data;
        let channelObj = {
            channel: {
                userDomain: selectedContactDetails.userDomain,
                channelName: channelName,
                description: description,
                chatOff
            },
        };
        let propsParticpants = [...participants];
        let newArry = giveUnique(propsParticpants, participants);
        let addUserObj = {
            channelName: channelName,
            userDomain: selectedContactDetails.userDomain,
            userIds: [...participants],

        };

        webSocketApiService.Edit(channelObj)
            .then(async () => {
                const addMembersParams = {
                    channelName: channelName,
                    userIds: participants,
                    userDomain: selectedDomain || 'onship',
                };
                webSocketApiService.UpdateParticipants(addUserObj);
                if (newArry && newArry.length > 0) {
                    webSocketApiService.UpdateParticipants(addUserObj);
                }
                // this.props.cancel();
                if (data?.imgFileName && data.imgFile) {
                    let { imgFileName, imgFile, updatedFile } = data;
                    uploadChannelImg(
                        channelId,
                        imgFileName,
                        imgFile
                    );
                    getUpdatedImg(channelId, updatedFile)
                    setAvatarUrl(updatedFile)

                } else {
                    fetchAllChannelsNSubChannels();
                }
                fetchAllChannelsNSubChannels();
                const updatedTimelineList = timeLine?.map((item) => {
                    if (item.conversationId === selectedContactDetails.channelId) {
                        return { ...item, channel: { ...item.channel, chatOff } };
                    }
                    return item;
                });
                getSubscibedChannels()

                dispatch(updateTimeLine(updatedTimelineList));
                dispatch(getTimeLine(selectedDomain))

                setEditGroupModal(false);
            })
            .catch((error) => {
                showToast('error', `Error while editing the ${channelName}. Please try again later.`);
                setEditGroupModal(false);
                dispatch(getTimeLine(selectedDomain))
            });
    };

    const handleShowGroupInfo = () => {
        setOpenGroupInfo(true);
        fullBotReset()
    };

    const handleBack = () => {
        setLoader(true);
        setOpenGroupInfo(false);
        setReloadChat((prev) => !prev);
    };

    return (
        <div className="flex-1 flex flex-col rounded-xl h-full shadow-[0_9px_13.8px_0_rgba(37,73,242,0.15)] overflow-auto bg-white">
            {!activeMessageChatArea && fallback && <div className="flex-1 flex flex-col items-center justify-center text-center p-8">
                <img src={fallback.image} alt="Empty" className={`${searchInput?.trim() ? "w-[248px] h-[260px] mb-[30px]" : "w-[347px] h-[260px] mb-[17px]"} `} />
                <h2 className="text-size-14 font-semibold text-primary-blue mb-[8px]">{fallback.heading}</h2>
                <p className={`text-size-14 text-purple-200 font-normal ${searchInput?.trim() ? "w-[252px]" : activeFilter === "unread" ? "w-full" : "w-full"}`}>{fallback.text}</p>
            </div>}
            {/* Chat Header */}
            {activeMessageChatArea &&
                <>
                    <div className="bg-[#15194B] text-white flex items-center justify-between p-4 rounded-tl-10 rounded-tr-10">
                        <div className="flex items-center gap-2">
                            {openGroupInfo &&
                                <div className="cursor-pointer" onClick={() => handleBack()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                        <path d="M19 12.5H5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 19.5L5 12.5L12 5.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            }
                            {!openGroupInfo && <div className={`flex items-center space-x-2 ${selectedContactDetails?.contact || selectedContactDetails?.userId ? "" : "cursor-pointer"}`} onClick={() => !(selectedContactDetails?.contact || selectedContactDetails?.userId) && handleShowGroupInfo()}>

                                {avatarUrl ?
                                    <img
                                        src={avatarUrl}
                                        alt="Avatar"
                                        className="rounded-full w-[40px] h-[40px]"
                                    />
                                    :
                                    <div className="bg-[rgb(201,197,197)] rounded-full w-[40px] h-[40px] flex items-center justify-center text-[14px]">
                                        {profileUtils}
                                    </div>
                                }
                                <div>
                                    <div className="font-semibold text-base">{(selectedContactDetails?.contact?.userName || selectedContactDetails?.userName) || selectedContactDetails?.channelName || ''}</div>
                                    <div className="flex space-x-1 text-xs">
                                        {(selectedContactDetails?.contact?.role || selectedContactDetails?.role) &&
                                            <>
                                                <span className="bg-[#05BC52] text-white px-2 rounded-[23px]">{selectedContactDetails?.contact?.role || selectedContactDetails?.role}</span>
                                                <span>Admin</span>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>}
                        </div>
                        <div className="flex items-center space-x-2 gap-[8px]">
                            {!selectedContactDetails?.chatOff ?
                                <>
                                    <button
                                        disabled={selectedContactDetails?.isRequestPendingForAccept}
                                        onClick={() =>
                                            handleAudioCall({
                                                emailAddress: userDetail?.user?.emailAddress,
                                                userId: (selectedContactDetails?.contact?.userId || selectedContactDetails?.userId),
                                                userName: userDetail?.user?.userName,
                                                conversation: selectedContactDetails,
                                            })
                                        }
                                        style={{
                                            opacity: selectedContactDetails?.isRequestPendingForAccept ? 0.5 : 1,
                                            cursor: selectedContactDetails?.isRequestPendingForAccept ? "not-allowed" : "pointer",
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 33" fill="none">
                                            <path d="M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5Z" fill="#2FC76F" />
                                            <path d="M22.0241 19.2168L19.9081 18.9748C19.6592 18.9455 19.4068 18.973 19.1701 19.0553C18.9333 19.1376 18.7183 19.2725 18.5411 19.4498L17.0081 20.9828C14.6424 19.7799 12.7194 17.8573 11.5161 15.4918L13.0581 13.9498C13.2354 13.7726 13.3702 13.5575 13.4524 13.3208C13.5347 13.084 13.5623 12.8317 13.5331 12.5828L13.2911 10.4828C13.2438 10.0764 13.0487 9.70155 12.743 9.42959C12.4373 9.15763 12.0423 9.00752 11.6331 9.00781H10.1901C9.24912 9.00781 8.46512 9.79181 8.52412 10.7328C8.96512 17.8498 14.6571 23.5328 21.7651 23.9748C22.7071 24.0328 23.4901 23.2498 23.4901 22.3078V20.8668C23.4922 20.4594 23.3437 20.0656 23.0731 19.7611C22.8025 19.4565 22.4289 19.2627 22.0241 19.2168Z" fill="white" />
                                        </svg>
                                    </button>

                                    <button
                                        disabled={selectedContactDetails?.isRequestPendingForAccept}
                                        onClick={() =>
                                            handleVideoCall({
                                                emailAddress: userDetail?.user?.emailAddress,
                                                userId: (selectedContactDetails?.contact?.userId || selectedContactDetails?.userId),
                                                userName: userDetail?.user?.userName,
                                                conversation: selectedContactDetails,
                                            })
                                        }
                                        style={{
                                            opacity: selectedContactDetails?.isRequestPendingForAccept ? 0.5 : 1,
                                            cursor: selectedContactDetails?.isRequestPendingForAccept ? "not-allowed" : "pointer",
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 33" fill="none">
                                            <path d="M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5Z" fill="#F74646" />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M9.333 11.5H19.333C19.792 11.5 20.167 11.875 20.167 12.333V15.25L23.5 11.917V21.083L20.167 17.75V20.667C20.1662 20.8879 20.0781 21.0994 19.9218 21.2555C19.7655 21.4116 19.5539 21.4995 19.333 21.5H9.333C9.11232 21.4992 8.9009 21.4112 8.74485 21.2551C8.58881 21.0991 8.50079 20.8877 8.5 20.667V12.333C8.5 11.875 8.875 11.5 9.333 11.5ZM18.5 19.833V13.167H10.167V19.833H18.5Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </button>
                                </> : null}

                            <button
                                disabled={selectedContactDetails?.isRequestPendingForAccept}
                                onClick={() => toggleContactTofavourites(selectedContactDetails)}
                                style={{
                                    opacity: selectedContactDetails?.isRequestPendingForAccept ? 0.5 : 1,
                                    cursor: selectedContactDetails?.isRequestPendingForAccept ? "not-allowed" : "pointer",
                                    background: "transparent",
                                    border: "none",
                                    padding: 0,
                                }}
                            >
                                <img src={getFavouriteIconImage()} />
                            </button>
                            {/* ----Group Setting Dots--- */}
                            {selectedContactDetails && selectedContactDetails.channelId &&
                                <div className="flex relative h-[18px]">
                                    <button className="" onClick={() => setShowGroupSetting(!showGroupSetting)}>
                                        <img src={ImagePath.dotsWhite} alt="whiteDots" className="h-full" />
                                    </button>
                                    {showGroupSetting &&
                                        <div className="w-[360px] px-[20px] py-[25px] bg-[#fff] flex flex-col gap-[12px]  rounded-[10px] shadow-md shadow-[rgba(37,73,242,0.15)] absolute top-full right-0 mt-[12px] z-[9999]">
                                            <h6 className="text-primary-blue text-[14px] font-semibold">Group Settings</h6>
                                            {(selectedContactDetails?.channelOwner?.userId === userID || isChannelAdmin) &&
                                                <button className="w-full flex items-center space-x-2 bg-[#F9F9FD] text-[16px] font-normal p-[12px]  rounded-[8px]" onClick={openGroupModal}>
                                                    <img src={ImagePath.editGroupLogo} />
                                                    <span className="text-primary-blue text-[14px]">Edit Group</span>
                                                </button>}


                                            {selectedContactDetails?.channelOwner?.userId !== userID ?
                                                <button className="w-full flex items-center space-x-2 bg-[#F9F9FD] text-[16px] font-normal p-[12px]  rounded-[8px] m-0" onClick={() => setOpenLeaveModal(true)}>
                                                    <img src={ImagePath.exitGroupLogo} />
                                                    <span className="text-primary-blue text-[14px]">Leave Group</span>
                                                </button> :
                                                <button className="w-full flex items-center space-x-2 bg-[#F9F9FD] text-[16px] font-normal p-[12px]  rounded-[8px] m-0" onClick={() => setOpenDeleteModal(true)}>
                                                    <img src={ImagePath.delgroup} />
                                                    <span className="text-primary-blue text-[14px]">Delete Group</span>
                                                </button>}
                                        </div>}
                                </div>}

                        </div>
                    </div>

                    {!openGroupInfo ?
                        <div style={{ position: "relative", width: "100%", height: "100%" }}>
                            {loader && (
                                <FrontmGifLogoLoader restartKey={restartKey} />
                            )}
                            <div id="chat-bot-project-root"></div>
                        </div>
                        :
                        <div className="max-w-[700px] mx-auto w-full">
                            <Groupinfo selectedContactDetails={selectedContactDetails} userID={userID} />
                            <Searchbar searchMembers={searchMembers} setSearchMembers={setSearchMembers} />
                            <Memberlist searchMembers={searchMembers}
                                selectedContactDetails={selectedContactDetails}
                                selectedGroupChatParticipants={selectedGroupChatParticipants}
                                channelAdmins={channelAdmins}
                                userID={userID}
                                isChannelAdmin={isChannelAdmin}
                                isGroupOwner={isGroupOwner}
                                setEditGroupModal={setEditGroupModal}
                                editChannel={editChannel}
                            />
                        </div>}

                    <ModalComfirm isOpen={openLeaveModal} onClose={closeLeaveModal} onConfirm={() => handleLeaveGroup(selectedDomain, selectedContactDetails?.channelName)} />
                    <DeleteGroupModal isOpen={openDeleteModal} onClose={closeDeleteModal} onConfirm={() => handleDeleteGroup(selectedContactDetails?.channelName, selectedDomain)} />
                    {editGroupModal &&
                        <ModalNewUI
                            onClose={() => setEditGroupModal(false)}
                            headerContent={''}
                            open={editGroupModal}
                            customDialogStyles={{ width: '1050px', maxWidth: '1200px', height: 'auto', overflowY: 'hidden' }}
                        >
                            <EditGroupModal editChannel={editChannel}

                                selectedContactDetails={selectedContactDetails}
                                groupContacts={contentList}
                                isGroupOwner={isGroupOwner}
                                isChannelAdmin={isChannelAdmin}
                                channelAdmins={channelAdmins}
                            />
                        </ModalNewUI>}
                </>
            }
        </div>
    )
}
export default ChatScreen